import React, { memo } from 'react';

import Button from '../helpers/Button';
import { AppPage } from '../AppPage';
import { Spinner } from '../helpers/Spinner';
import { TableCard } from '../helpers/TableCard';
import { CategoryTable } from './CategoryTable';
import { Editor } from './Editor';

import style from './style.module.css';

const CategoryManagementComponent = ({
  loading,
  mode,
  errors,
  category,
  isLinkable,
  parentId,
  parents,
  agreementCategories,
  sort,
  isSuper,
  showParent,
  onAdd,
  onEdit,
  onSave,
  onCancel,
  onDelete,
  onChange,
  onClick,
}) => {
  const toolbar = mode === 'view' && (
    <div className={style.toolbar}>
      <Button disabled={loading || !isSuper} onClick={onAdd}>
        <i aria-hidden="true" className="fa fa-plus" /> Add New
      </Button>
    </div>
  );

  return (
    <AppPage overline="Management" title="Agreement Categories" toolbar={toolbar}>
      <Editor
        category={category}
        errors={errors}
        isLinkable={isLinkable}
        isSuper={isSuper}
        loading={loading}
        mode={mode}
        onCancel={onCancel}
        onChange={onChange}
        onSave={onSave}
        parentId={parentId}
        parents={parents}
        showParent={showParent}
      />
      <TableCard className={style.table}>
        {loading && <Spinner />}
        <CategoryTable
          agreementCategories={agreementCategories}
          isSuper={isSuper}
          onClick={onClick}
          onDelete={onDelete}
          onEdit={onEdit}
          sort={sort}
        />
      </TableCard>
    </AppPage>
  );
};

export const CategoryManagement = memo(CategoryManagementComponent);
